import React, { useState, useEffect } from "react";
import { Downloading } from "./Downloading";
import { Running } from "./Running";
import { useAppDetection, useAnalytics } from "hooks";

/**
 * The App prompts and download messaging.
 */
const App = (props) => {
  /**
   *  The state can be:
   *   1. downloading - The app is downloading.
   *   2. running - The detection is running.
   */
  const [state, setState] = useState({});
  const analytics = useAnalytics();

  const onDetectionDone = (evt) => {
    //if (evt.success) {
    // Success so we're done here.
    props.onDone(evt);
    //}
  };

  /**
   *  Progress event handler. Changes the running state.
   *
   *  @param {object} evt - The event.
   */
  const onProgress = (evt) => {
    if (evt.message) {
      if (evt.id === 30) {
        // ID of 30 means the detection process has heard from the application.
        // This is the only client-side proof the EXE actually started - no EXE change needed.
        analytics.launched();
        setState({ running: true });
      }
    }
  };

  // The hook into the detection library.
  const runAppDetection = useAppDetection(onProgress, onDetectionDone);

  // Start the detection process.
  useEffect(
    () => {
      analytics.downloadStarted();
      setState({ downloading: true });
      runAppDetection(); // Run the detection in the library.
    },
    [] // Just once.
  );

  // Render.
  return (
    <>
      <div className="text-start">
        {state.downloading && <Downloading />}
        {state.running && <Running />}
      </div>
    </>
  );
};

export default App;
